import { useEffect, useState, useCallback } from "react";
import { getActivityGroupsByDate } from "../api/activitiesApi";
import dayjs from "dayjs";

export default function useActivityGroupsByDate(selectedDate, campus) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchGroups = useCallback(async () => {
    if (!selectedDate) {
      setGroups([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const dateStr = dayjs(selectedDate).format("YYYY-MM-DD");
      const data = await getActivityGroupsByDate(dateStr, campus);
      setGroups(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e);
      setGroups([]);
    } finally {
      setLoading(false);
    }
  }, [selectedDate, campus]);

  useEffect(() => {
    fetchGroups();
  }, [fetchGroups]);

  return {
    groups,
    loading,
    error,
    refetch: fetchGroups,
  };
}